// extracted by mini-css-extract-plugin
export default {"content_container":"bookings_content_container__WKs8a","checkin_instruction_text":"bookings_checkin_instruction_text__OFRgf"};